/* eslint-disable react-refresh/only-export-components */
import { Outlet } from "@tanstack/react-router";

export const ReceiptsLayout = () => {
  return <Outlet />;
};

export { default as ReceiptList } from "./ReceiptList";
export { default as ReceiptCreate } from "./ReceiptCreate";
export { default as ReceiptEdit } from "./ReceiptEdit";
export { default as ReceiptView } from "./ReceiptView";
